import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment';
// import { getVistaPresupuestosInternosList, getVistaPresupuestosInternosAbiertosList } from '../../helpers/user_mv';

const state = {
    flujoFondosPresupuestos: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    fechaDesde: moment(new Date()).add(-60, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).add(60, 'days').format('YYYY-MM-DD'),
};

const mutations = {
    updateField,

    'INICIALIZAR_FLUJO_FONDOS_PRESUPUESTOS' (state) {
        state.flujoFondosPresupuestos = [];
    },
    'SET_FLUJO_FONDOS_PRESUPUESTOS' (state, flujoFondosPresupuestos) {
        state.flujoFondosPresupuestos = flujoFondosPresupuestos;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

const getters = {
    getField,
};

const actions = {
    getFlujoFondosPresupuestos ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_FLUJO_FONDOS_PRESUPUESTOS');

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
                + '&fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
            
            apiAxios.get('flujo-fondos/presupuestos' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }

                    commit('SET_FLUJO_FONDOS_PRESUPUESTOS', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    delete ( {}, flujoFondosPresupuestoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('flujo-fondos/presupuestos/' + flujoFondosPresupuestoId + '/delete')
            .then(() => resolve())
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}